(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"), require("antd"), require("antdCssinjs"), require("icons"), require("mermaid"));
	else if(typeof define === 'function' && define.amd)
		define([, , , , , ], factory);
	else if(typeof exports === 'object')
		exports["antdx"] = factory(require("react"), require("react-dom"), require("antd"), require("antdCssinjs"), require("icons"), require("mermaid"));
	else
		root["antdx"] = factory(root["React"], root["ReactDOM"], root["antd"], root["antdCssinjs"], root["icons"], root["mermaid"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__868__, __WEBPACK_EXTERNAL_MODULE__1238__, __WEBPACK_EXTERNAL_MODULE__9999__, __WEBPACK_EXTERNAL_MODULE__283__, __WEBPACK_EXTERNAL_MODULE__5377__, __WEBPACK_EXTERNAL_MODULE__7798__) {
return 